import type { HTMLAttributes } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './badge.module.scss';

const styles = pickCss(css, css.root);

type BadgeVariant =
  | 'active'
  | 'pending'
  | 'inactive'
  | 'error'
  | 'booked'
  | 'delivered'
  | 'high'
  | 'medium'
  | 'low';

type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  dot?: boolean;
  variant?: BadgeVariant;
};

export const Badge = ({
  dot = false,
  variant = 'active',
  className,
  children,
  ...restProps
}: BadgeProps) => (
  <span className={styles({ variant }, className)} {...restProps}>
    {dot && <span className={css.dot} />}
    {children}
  </span>
);
